import { render, staticRenderFns } from "./BadgePostPremium.vue?vue&type=template&id=352ce5b1&scoped=true&"
import script from "./BadgePostPremium.vue?vue&type=script&lang=js&"
export * from "./BadgePostPremium.vue?vue&type=script&lang=js&"
import style0 from "./BadgePostPremium.vue?vue&type=style&index=0&id=352ce5b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352ce5b1",
  null
  
)

export default component.exports